/**
 * Get url of a smaller version of a product image
 * (We don't check if the url is valid)
 *
 * @param src original url of the image
 * @returns url of a smaller version of the image
 */
export const getSmallerProductImageSrc = (src: string): string => {
  // Url pattern for product image
  const searchValue = /\/media\/catalog\/product\/cache\/(\d*)\/image\//;
  const matchValue = src.match(searchValue)?.[0];

  if (!matchValue) {
    return src;
  }

  const replaceCacheIndex = matchValue.replace(/\/cache\/(\d*)\//, "/cache/1/");

  // Dimensions of a product image pre-existing version
  const width = 169;
  const height = 225;

  // Url of the smaller version
  const replaceValue = `${replaceCacheIndex}${width}x${height}/`;

  return src.replace(searchValue, replaceValue);
};
